import { api } from "@/api/client";

export type StatusImportacaoIdoso = "IMPORTADO" | "IMPORTADO_SEM_CPF" | "DUPLICADO" | "ERRO";

export interface LinhaImportacaoIdoso {
  linha: number;
  dados: { nome: string; sobrenome?: string } | null;
  status: StatusImportacaoIdoso;
  mensagem?: string;
}

export interface ResumoImportacao {
  total: number;
  importados: number;
  semCpf: number;
  duplicados: number;
  erros: number;
}

export function montarResumo(linhas: LinhaImportacaoIdoso[]): ResumoImportacao {
  return {
    total: linhas.length,
    importados: linhas.filter((l) => l.status === "IMPORTADO").length,
    semCpf: linhas.filter((l) => l.status === "IMPORTADO_SEM_CPF").length,
    duplicados: linhas.filter((l) => l.status === "DUPLICADO").length,
    erros: linhas.filter((l) => l.status === "ERRO").length,
  };
}

// O legado precisa de `headers: { 'Content-Type': undefined }` +
// `transformRequest: angular.identity` só pra impedir o AngularJS de
// serializar o FormData como JSON por padrão. axios não tem esse problema —
// detecta FormData e define multipart/form-data com boundary sozinho.
export async function importarIdosos(instituicaoId: number, arquivo: File): Promise<LinhaImportacaoIdoso[]> {
  const formData = new FormData();
  formData.append("file", arquivo);
  const { data } = await api.post<LinhaImportacaoIdoso[]>(
    `enfermagem/Importacao/Idoso/Painel/${instituicaoId}`,
    formData,
  );
  return data;
}

// Mesmo contrato de status do idoso, exceto IMPORTADO_SEM_CPF: para
// profissional o CPF é obrigatório, então CPF ausente/inválido vira ERRO
// (a linha não é importada) em vez de uma variante "sem CPF".
export type StatusImportacaoProfissional = "IMPORTADO" | "DUPLICADO" | "ERRO";

export interface LinhaImportacaoProfissional {
  linha: number;
  dados: { nome: string; sobrenome?: string } | null;
  status: StatusImportacaoProfissional;
  mensagem?: string;
}

export function montarResumoProfissional(linhas: LinhaImportacaoProfissional[]) {
  return {
    total: linhas.length,
    importados: linhas.filter((l) => l.status === "IMPORTADO").length,
    duplicados: linhas.filter((l) => l.status === "DUPLICADO").length,
    erros: linhas.filter((l) => l.status === "ERRO").length,
  };
}

export async function importarProfissionais(instituicaoId: number, arquivo: File): Promise<LinhaImportacaoProfissional[]> {
  const formData = new FormData();
  formData.append("file", arquivo);
  const { data } = await api.post<LinhaImportacaoProfissional[]>(
    `instituicao/Importacao/Profissional/Painel/${instituicaoId}`,
    formData,
  );
  return data;
}
